import React from 'react';
import PropTypes from 'prop-types';

const SmartSkills = () => {
  return (
    <svg
      viewBox="0 0 26 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8852 19.8775C15.9199 19.5962 15.943 19.3038 15.943 19C15.943 18.6962 15.9199 18.4038 15.8736 18.1225L17.8292 16.6375C18.0028 16.5025 18.0491 16.255 17.9449 16.0637L16.0935 12.9475C15.9777 12.745 15.7347 12.6775 15.5264 12.745L13.2237 13.645C12.7377 13.285 12.2285 12.9925 11.6615 12.7675L11.3143 10.3825C11.2796 10.1575 11.0829 10 10.8515 10H7.14853C6.91709 10 6.73195 10.1575 6.69723 10.3825L6.35008 12.7675C5.78307 12.9925 5.26234 13.2962 4.7879 13.645L2.48513 12.745C2.27684 12.6662 2.03384 12.745 1.91812 12.9475L0.0666476 16.0637C-0.0490694 16.2662 -0.00278243 16.5025 0.182365 16.6375L2.13798 18.1225C2.0917 18.4038 2.05698 18.7075 2.05698 19C2.05698 19.2925 2.08012 19.5962 2.12641 19.8775L0.170793 21.3625C-0.0027827 21.4975 -0.0490694 21.745 0.0550759 21.9362L1.90655 25.0525C2.02226 25.255 2.26527 25.3225 2.47356 25.255L4.77633 24.355C5.26234 24.715 5.7715 25.0075 6.33851 25.2325L6.68566 27.6175C6.73195 27.8425 6.91709 28 7.14853 28H10.8515C11.0829 28 11.2796 27.8425 11.3028 27.6175L11.6499 25.2325C12.2169 25.0075 12.7377 24.7038 13.2121 24.355L15.5149 25.255C15.7232 25.3338 15.9662 25.255 16.0819 25.0525L17.9334 21.9362C18.0491 21.7337 18.0028 21.4975 17.8176 21.3625L15.8852 19.8775ZM9 22.375C7.09067 22.375 5.52849 20.8562 5.52849 19C5.52849 17.1438 7.09067 15.625 9 15.625C10.9093 15.625 12.4715 17.1438 12.4715 19C12.4715 20.8562 10.9093 22.375 9 22.375Z"
        fill="#464646"
        fillOpacity="0.8"
      />
      <path
        d="M18 16C22.4183 16 26 12.4183 26 8C26 3.58172 22.4183 0 18 0C13.5817 0 10 3.58172 10 8C10 12.4183 13.5817 16 18 16Z"
        fill="#075A28"
      />
      <mask
        id="mask0_523:2549"
        maskUnits="userSpaceOnUse"
        x="10"
        y="0"
        width="16"
        height="16"
      >
        <path
          d="M18 16C22.4183 16 26 12.4183 26 8C26 3.58172 22.4183 0 18 0C13.5817 0 10 3.58172 10 8C10 12.4183 13.5817 16 18 16Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_523:2549)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8 11.1565H17.2C17.0895 11.1565 17 11.246 17 11.3565C17 11.4669 17.0895 11.5565 17.2 11.5565H18.8C18.9105 11.5565 19 11.4669 19 11.3565C19 11.246 18.9105 11.1565 18.8 11.1565ZM18.8 11.9561H17.2C17.0895 11.9561 17 12.0457 17 12.1561C17 12.2666 17.0895 12.3561 17.2 12.3561H18.8C18.9105 12.3561 19 12.2666 19 12.1561C19 12.0457 18.9105 11.9561 18.8 11.9561ZM18.8997 12.7557H17.0997L17.5749 13.0685C17.6365 13.1237 17.7269 13.1557 17.8209 13.1557H18.1789C18.2725 13.1557 18.3629 13.1237 18.4249 13.0685L18.8997 12.7557ZM20.3997 7.2347C20.3997 8.66271 19.1141 9.62831 19.1141 10.7547H16.8853C16.8853 9.62831 15.5997 8.66271 15.5997 7.2347C15.5997 5.7459 16.7989 4.9267 17.9985 4.9267C19.1985 4.9267 20.3997 5.7467 20.3997 7.2347ZM22 6.95611V7.5049H20.9848C20.9928 7.4157 21 7.3257 21 7.2329C20.9991 7.14076 20.9944 7.04868 20.986 6.95691H22V6.95611ZM17.7403 4.00546V3.22266H18.2883V4.3416C18.1061 4.32444 17.9227 4.32351 17.7403 4.3388V4.00546ZM19.9493 4.95541L20.5773 4.25942L20.9854 4.62741L20.3445 5.3394C20.2445 5.2234 20.1045 5.0714 19.9485 4.95941L19.9493 4.95541ZM15.6536 5.33862L15.0124 4.62622L15.4204 4.25942L16.0476 4.95422C15.8904 5.06622 15.7528 5.21662 15.6528 5.33542L15.6536 5.33862ZM15.0152 7.50811H14V6.95611H15.014C15.0056 7.04789 15.001 7.13996 15 7.23211C15 7.32571 15.0072 7.41611 15.0152 7.50491V7.50811Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default SmartSkills;
